import { AreaItem, RepeatingTask } from "./RepeatingTasks";

export class AreaWrapper {
  Areas : AreaItem[]
}
